import { createSlice } from '@reduxjs/toolkit';
import { engagementInitialState } from './engagement-initial-state';

const engagementViewSlice = createSlice({
  name: 'engagementView',
  initialState: engagementInitialState,
  reducers: {
    setEngagements: (state, action) => {
      state.engagements = action.payload;
    },
    setPagination: (state, action) => {
      state.pagination = action.payload;
    },
    setAllInformation: (state, action) => {
      state.allInformation = action.payload;
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
  },
});

export const {
  setEngagements,
  setAllInformation,
  setPagination,
  setIsLoading,
} = engagementViewSlice.actions;
export default engagementViewSlice.reducer;
